import React from 'react';

import styles from './Input.module.scss';

const Textarea = ({name, label, value = '', onChange = () => {}, required = false}) => {
    return (
        <div className={`${styles.inputData} ${styles.textarea} ${value !== '' && styles.filled}`}>
            <textarea name={name} rows={16} cols={80} required={required} value={value} onChange={onChange}></textarea>
            <br />
            <div className={styles.underline}></div>
            <label htmlFor={name}>{label}</label>
            <br />
        </div>
    )
};

export default Textarea;